"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPerpetualListing = void 0;
const common_1 = require("../../../../common");
const constants_1 = require("../../../constants");
const helpers_1 = require("../../../helpers");
const offer_1 = require("../offer");
const anchor_1 = require("@coral-xyz/anchor");
const token_1 = require("@coral-xyz/anchor/dist/cjs/utils/token");
const spl_token_1 = require("@solana/spl-token");
const createPerpetualListing = (_a) => __awaiter(void 0, [_a], void 0, function* ({ programId, connection, args, accounts, sendTxn, }) {
    const amountToGet = new anchor_1.BN((0, offer_1.getFullLoanBodyFromBorrowerSendedAmount)({
        borrowerSendedAmount: Number(args.amountToGetBorrower),
        upfrontFeeBasePoints: args.upfrontFeeBasePoints,
    }));
    const program = (0, helpers_1.returnAnchorProgram)(connection);
    const instructions = [];
    const [mutualBondTradeTxnVault] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.MUTUAL_BOND_TRADE_TXN_VAULT)], program.programId);
    const bondOfferSeed = Math.ceil(Math.random() * 1000000);
    const [fraktBond] = anchor_1.web3.PublicKey.findProgramAddressSync([constants_1.ENCODER.encode(constants_1.FRAKT_BOND_PREFIX), accounts.userPubkey.toBuffer(), constants_1.ENCODER.encode(bondOfferSeed.toString())], program.programId);
    const [bondTradeTransaction] = anchor_1.web3.PublicKey.findProgramAddressSync([constants_1.ENCODER.encode(constants_1.BOND_TRADE_TRANSACTOIN_PREFIX), accounts.userPubkey.toBuffer(), fraktBond.toBuffer()], program.programId);
    const [bondOffer] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BOND_OFFER_PREFIX), accounts.userPubkey.toBuffer(), fraktBond.toBuffer()], program.programId);
    const userTokenAccount = yield (0, common_1.findAssociatedTokenAddress)(accounts.userPubkey, accounts.nftMint);
    const editionInfo = (0, helpers_1.getMetaplexEditionPda)(accounts.nftMint);
    const nftMetadata = (0, helpers_1.getMetaplexMetadata)(accounts.nftMint);
    const ownerTokenRecord = (0, helpers_1.findTokenRecordPda)(accounts.nftMint, userTokenAccount);
    const targetRuleSet = args.ruleSet || accounts.protocolFeeReceiver;
    const targetDelegatePubkey = accounts.protocolFeeReceiver;
    const [banxPointsMap] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_POINTS_MAP_PREFIX), accounts.nftMint.toBuffer()], program.programId);
    const remainingAccounts = [
        {
            pubkey: ownerTokenRecord,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: targetRuleSet,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: targetDelegatePubkey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: banxPointsMap,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: constants_1.AUTHORIZATION_RULES_PROGRAM,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: constants_1.METADATA_PROGRAM_PUBKEY,
            isSigner: false,
            isWritable: true,
        },
    ];
    const [rentVault, rentVaultBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
        constants_1.ENCODER.encode(constants_1.RENT_VAULT),
    ], program.programId);
    instructions.push(yield program.methods
        .createPerpetualListing(new anchor_1.BN(bondOfferSeed), amountToGet, args.aprRate, args.isBorrowerListing, (0, helpers_1.createDecodeEnum)(args.lendingTokenType, {}), args.terminationFreeze)
        .accountsStrict({
        user: accounts.userPubkey,
        mutualBondTradeTxnVault: mutualBondTradeTxnVault,
        systemProgram: anchor_1.web3.SystemProgram.programId,
        rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        associatedTokenProgram: token_1.ASSOCIATED_PROGRAM_ID,
        bondTradeTransaction,
        fraktBond,
        collateralMint: accounts.nftMint,
        hadoMarket: accounts.hadoMarket,
        userTokenAccount: userTokenAccount,
        bondOffer,
        metadata: nftMetadata,
        edition: editionInfo,
        rentVault
    })
        .remainingAccounts([...remainingAccounts])
        .instruction());
    const transaction = new anchor_1.web3.Transaction();
    for (let instruction of instructions)
        transaction.add(instruction);
    const signers = [];
    yield sendTxn(transaction, signers);
    return {
        instructions,
        signers,
        accounts: {
            fraktBond: fraktBond,
            bondOffer: bondOffer,
            bondTradeTransaction: bondTradeTransaction,
        },
    };
});
exports.createPerpetualListing = createPerpetualListing;
